exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"maxWidth": "120rem",
	"xsmallBp": "(min-width: 25rem)",
	"smallBp": "(min-width: 40rem)",
	"mediumBp": "(min-width: 60rem)",
	"largeBp": "(min-width: 80rem)",
	"xlargeBp": "(min-width: 120rem)"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/style/breakpoints.css
 ** module id = 3
 ** module chunks = 0
 **/